import { render, staticRenderFns } from "./PopupUser.vue?vue&type=template&id=66b976c4&"
import script from "./PopupUser.vue?vue&type=script&lang=js&"
export * from "./PopupUser.vue?vue&type=script&lang=js&"
import style0 from "./PopupUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports